/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Motivation_Example_1Inputs */

const en_us2_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to feel strong again after two years off.`)
};

const pt_br2_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero me sentir forte de novo depois de dois anos parado.`)
};

const es_419_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiero volver a sentirme fuerte después de dos años sin entrenar.`)
};

const pt_pt2_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero voltar a sentir-me forte depois de dois anos parado.`)
};

const fr_fr2_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je veux retrouver ma force après deux ans d'arrêt.`)
};

const de_de2_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich will mich nach zwei Jahren Pause wieder stark fühlen.`)
};

const it_it2_onboarding_motivation_example_1 = /** @type {(inputs: Onboarding_Motivation_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voglio sentirmi di nuovo forte dopo due anni di stop.`)
};

/**
* | output |
* | --- |
* | "I want to feel strong again after two years off." |
*
* @param {Onboarding_Motivation_Example_1Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_motivation_example_1 = /** @type {((inputs?: Onboarding_Motivation_Example_1Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Motivation_Example_1Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_motivation_example_1(inputs)
	if (locale === "es-419") return es_419_onboarding_motivation_example_1(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_motivation_example_1(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_motivation_example_1(inputs)
	if (locale === "de-DE") return de_de2_onboarding_motivation_example_1(inputs)
	if (locale === "it-IT") return it_it2_onboarding_motivation_example_1(inputs)
	return en_us2_onboarding_motivation_example_1(inputs)
});
export { onboarding_motivation_example_1 as "onboarding.motivation.example_1" }